/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROOMS_LISTIN_URL, AVAILABILITY_URL } from "../services/apiUrl";
import { useRest, CALL_TYPES } from "../services/rest/api";
import Utility from "../utility/utility";

const Room = (props) => {
  const navigate = useNavigate();
  const gameData = useSelector(
    (state) => state.joinReducer.data
  );

  const [rooms, setRooms] = useState([]);
  const [room_id, setRoomID] = useState("");

  useEffect(async() => {
    Utility.isSignedIn(gameData).then((value) => {
      if (value) {
        navigate("/gameboard");
      }
    });
  }, [gameData]);
  useEffect(async() => {
   
    
    const socket = await  Utility.getConnectedSocket()
    socket.emit("client_gamerooms");
    
    socket.on(
      "server_gamerooms", (data) => {
        const rooms = JSON.parse(data)
        setRooms(rooms.result.rooms)
      }
    );
    

    return () => {
         Utility.disconnectSocket()
    }
  },[props]);
  
  // check space available in room
  const {
    data: availabiltydata,
    fetchData: RommJoinAbility,
  } = useRest({
    URL: AVAILABILITY_URL,
    CALL_TYPE: CALL_TYPES.POST,
    PAYLOAD: {
      room_id: room_id.toString(),
      showSuccessToast: false
    },
    lazy: true,
  });

  async function CheckingRoom(id) {
    Utility.showToast("info", "Loading...");
    setRoomID(id);
  }
  useEffect(() => {
    if(room_id !== ""){
      RommJoinAbility();
    }
  }, [room_id]);

  useEffect(() => {
    if(availabiltydata){
      if(availabiltydata?.status_code === 200){
        navigate("/name",{state:{
          room_id: room_id,
        }});
      }
      else {
        Utility.showToast("error", "Some error occured, Try to refresh the page");
      }
    }
  }, [availabiltydata]);

  //get the room listing
  const {
    data,
    fetchData: RommListingFetch,
  } = useRest({
    URL: ROOMS_LISTIN_URL,
    CALL_TYPE: CALL_TYPES.POST,
    PAYLOAD: {
      showSuccessToast: false
    },
    lazy: true,
  });

  useEffect(() => {
    if(data == null){
      //RommListingFetch();
    }
  });

  useEffect(() => {
    if(data !== null){
    // setRooms(data.data);
    }
  }, [data]);

  const RoomListingData = rooms.map((item, index) => (
    <div className="text-center mt-3" key={index}>
      <button
        onClick={(e) => CheckingRoom(item.id)}
        type="button"
        rel={item.id}
        className="btn border-roome-button   encode-sans"
      >
        Room {item.id}
      </button>
    </div>
  ));

  return (
    <>
      <div className="background room-page">
        <div className="container">
          <div className="text-center mt-5">
            <h1 className="text-white font-room-section  encode-sans">
              Select Breakout Room
            </h1>
          </div>
          <div className="d-none d-md-block breakout-room-info-wrapper">
            <div className="border border-danger rounded p-3 encode-sans font-italic text-danger text-center breakout-room-info">
              Choose the Breakout Room number that matches your Meeting breakout room number.
            </div>
          </div>
          <div className="d-block d-md-none text-center mt-3">
            <div className="border border-danger rounded p-3 encode-sans font-italic text-danger text-center breakout-room-info d-inline-block">
              Choose the Breakout Room number that matches your Meeting breakout room number.
            </div>
          </div>
          {RoomListingData && RoomListingData.length > 0 ? (
            <>{RoomListingData}</>
          ) : (
            <div  className="text-center mt-3">
              <span>Please wait...</span>
            </div>
          )}

          
        </div>
      </div>
    </>
  );
};

export default Room;
